import React, {Component} from 'react'
import CardWrapper from '../../../../../components/Cards/CardWrapper/CardWrapper';
import { Grid } from '@material-ui/core';
import Subtitle from '../../../../../components/Texts/Subtitle';
import { blue } from '@material-ui/core/colors';
import ProductPatientStatsTable from './ProductPatientStatsTable';
import ProductPatientStatsChart from './ProductPatientStatsChart';

class ProductPatientStats extends Component {
  render(){

    const {data} = this.props

    return(
      <CardWrapper>
        <div style={{padding:32}}>
          <Grid container spacing={2} alignItems='center'>
            <Grid item xs={12}>
              <Subtitle medium text='Estadísticas Beneficiarios por producto' color={blue[900]}/>
            </Grid>
            <Grid item xs={12}>
              <ProductPatientStatsTable data={data.table}/>
            </Grid>
            <Grid item xs={12}>
              <div style={{overflowX:'auto'}}>
                <ProductPatientStatsChart data={data.chartTable}/>
              </div>
            </Grid>
          </Grid>
        </div>
      </CardWrapper>
    )
  }
}

export default ProductPatientStats